import request from '@/request/request'

// 查询车船信息列表
export function listCarShip(query) {
    return request({
        url: '/api/equipment-server/carShip/list',
        method: 'get',
        params: query
    })
}

// 查询车船信息详细
export function getCarShipById(id) {
    return request({
        url: '/api/equipment-server/carShip/' + id,
        method: 'get'
    })
}

// 新增车船信息
export function addCarShip(data) {
    return request({
        url: '/api/equipment-server/carShip',
        method: 'post',
        data: data
    })
}

// 修改车船信息
export function updateCarShip(data) {
    return request({
        url: '/api/equipment-server/carShip/edit',
        method: 'post',
        data: data
    })
}

// 删除车船信息
export function delCarShip(id) {
    return request({
        url: '/api/equipment-server/carShip/delete/' + id,
        method: 'post'
    })
}

// 查询有轨迹的车船列表
export function listCarShipTrack(data) {
    return request({
        url: '/api/equipment-server/carShip/searchByDriving',
        method: 'post',
        data: data
    })
}

// 查询行驶轨迹列表
export function carShipDrivingTrack(query) {
    return request({
        url: '/api/equipment-server/carDrivingTrack/list',
        method: 'get',
        params: query
    })
}